import React from 'react';
import { MasterProduct } from '../types';
import { Tag } from 'antd';

export const OptionContent: React.FC<{ product: MasterProduct }> = ({
  product,
}: {
  product: MasterProduct;
}) => {
  const unitOfMeasure = !!product.unit_of_measure && `(${product.unit_of_measure})`;

  return (
    <div className="flex flex-row product" data-testid={`option-content-${product.product_id}`}>
      <div className="flex flex-col w-65% text-ellipsis overflow-hidden whitespace-nowrap">
        <div
          className="p-0 m-0 text-14 text-neutral-100 pr-6"
          title={`${product.product_name} ${unitOfMeasure}`}
        >
          {product.product_name}
          <span className="text-neutral-60 ml-3">{unitOfMeasure}</span>
        </div>
        <div className="p-0 m-0 text-neutral-60 text-12 manufacturer_name">
          {product.manufacturer_name}
        </div>
      </div>
      <div className="flex text-right w-35% justify-end items-center product_type">
        {product.category && (
          <Tag className="rounded-4 text-neutral-60 bold border-none bg-neutral-10">
            {product.category}
          </Tag>
        )}
      </div>
    </div>
  );
};
